<template>
    <b-container fluid>
        <b-row align-h="center">
            <b-col cols="12" sm="10" lg="5">

                <div class="div-section-header">
                    <b-row>
                        <b-col cols="12">
                            <div>
                            <span class="txt-section-title">GDPR Remove Consent</span>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <div>
                    <!-- <p class="font-weight-bold">GDPR Remove Consent</p> -->
                    <p>As stated in the Privacy policy posted on this site, residents of the EEA have the right to request that their Personally Identifiable Information be removed.</p>
                    <p>By removing consent, we will no longer use and disclose such Personally Identifiable Information in accordance with our Privacy Policy and our Terms of Use, and as permitted or required by law.</p>
                    <p>NOTE: Once your consent is removed, this training account will be deactivated and any training records will be archived solely for internal use.</p>
                    <p>To remove consent, you must first confirm your identity. To confirm your identity, we will send you an Identity Confirmation email to your email address on record with a confirmation link.</p>
                    <p>To start this process, click the checkbox and click the Submit Button.</p>
                </div>

                <b-overlay :show="busy">
                    <b-card bg-variant="light">
                        <b-form @submit.stop.prevent="submit">
                            <!--  -->
                            <b-form-checkbox
                            id="checkbox-1"
                            v-model="checkbox"
                            name="checkbox-1"
                            value="checked"
                            unchecked-value="unchecked"
                            >
                            I reside in the European Economic Area (EEA) and would like to remove my consent related to my Personally Identifiable Information (PII).
                            </b-form-checkbox>

                            <transition name="fade" mode="out-in">
                                <b-alert v-if="error" key="error-box" show variant="danger" dismissible class="mt-2">
                                    {{errorMsg}}
                                </b-alert>
                                <b-alert v-if="success" key="success-box" show variant="success" dismissible class="mt-2">
                                    Check your email for instructions on completing this operation.
                                    <div class="mt-2 text-center">
                                        <b-button to="/home">Home</b-button>
                                    </div>
                                </b-alert>
                            </transition>

                            <div class="text-center mt-2 mb-2">
                                <b-button type="submit" variant="info">Submit Request</b-button>
                            </div>
                        </b-form>
                    </b-card>
                </b-overlay>

            </b-col>
        </b-row>
    </b-container>
</template>

<script>
/* eslint-disable */

// Using v-model with custom components
// https://stackoverflow.com/questions/49072799/vuejs-how-to-pass-an-object-as-prop-and-have-the-component-update-sub-objects

import service from "@/service/service"

export default {
  name: "Gdpr",
  data() {
    return {
        msg: "",
        show: false,
        debug: false,
        loading: false,
        busy: false,
        error: false,
        success: false,
        studentHash: null,
        checkbox: null
    }
  },
  methods: { 
    submit(e) {

      if ( this.checkbox == 'checked') {
        this.error = false
        this.success = false
        this.busy = true

        service
            .removeConsent(this.studentHash)
            .then( res => {
              if (this.debug) console.log(res.data);
              if (res.status) {
                  this.success = true
              }
              else {
                  this.success = false
                  this.errorMsg = data.errorMsg || 'Service error.'
                  this.error = true
              }
            })
            .finally( () => { 
              this.busy = false
            })
            .catch(e => {
              console.log(e);
              this.error = true;
            })
      }
      else {
        this.errorMsg = 'Check the checkbox before clicking the Submit Request button.'
        this.error = true
      }
    }
  },
  created() {
    this.studentHash = this.$root.getToken()
  },
  mounted() { console.log('GDPR mounted')}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Gdpr.vue